<form *ngIf="varlidation" [formGroup]="form">
    <referring-physician-autocomplete formControlName="ReferringPhysician" [readOnly]="readonly"></referring-physician-autocomplete>

    <app-referring-physician-institute formControlName="ReferringPhysicianInstitute" [readOnly]="readonly"></app-referring-physician-institute>

    <mat-form-field class="card-inline margin-right-small">
        <input matInput formControlName="PrescriptionDate" #dateOrder [matDatepicker]="picker" placeholder="Fecha {{ validityDays }}" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="card-inline margin-right-small">
        <mat-label>Número de afiliado</mat-label>
        <input [mask]="mask" formControlName="CredentialNumber" [showMaskTyped]="showMaskTyped" [dropSpecialCharacters]="false" type="text" matInput />
    </mat-form-field>

    <mat-form-field *ngIf="varlidation.RequiredPreAuth" class="card-inline margin-right-small">
        <mat-label>Número de pre autorización</mat-label>
        <input formControlName="PreAuth" type="text" matInput />
    </mat-form-field>

    <mat-form-field *ngIf="!isPreadmission && varlidation.RequiredCode" class="card-inline margin-right-small">
        <mat-label>Código de seguridad</mat-label>
        <input formControlName="Code" type="text" matInput />
    </mat-form-field>

    <button *ngIf="varlidation.RequiredValidation && !readonly" [disabled]="lodading" type="button" (click)="executeValidation()" class="card-inline margin-right-small margin-left-small" type="button" mat-mini-fab>
    <mat-icon *ngIf="!needCancel">cloud_done</mat-icon>
    <mat-icon *ngIf="needCancel">cloud_off</mat-icon>
  </button>

    <button *ngIf="
      !varlidation.RequiredValidation &&
      showValidationProceduresButton &&
      !readonly
    " [disabled]="lodading" type="button" (click)="showValidationProcedures()" class="card-inline margin-right-small margin-left-small" type="button" mat-mini-fab>
    <mat-icon>cloud_done</mat-icon>
  </button>

    <mat-form-field *ngIf="!isPreadmission" class="card-inline margin-right-small">
        <mat-label>Número de autorización</mat-label>
        <input [readonly]="needCancel" formControlName="AuthorizationNumber" type="text" matInput />
    </mat-form-field>
</form>